import { render, staticRenderFns } from "./InstrumentsBar.vue?vue&type=template&id=56fa071d&scoped=true&"
import script from "./InstrumentsBar.vue?vue&type=script&lang=js&"
export * from "./InstrumentsBar.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentsBar.vue?vue&type=style&index=0&id=56fa071d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa071d",
  null
  
)

export default component.exports